var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "#66BB6A",
    stroke: "#66BB6A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1C4.58273 1 1 4.57914 1 9C1 13.4209 4.58273 17 9 17C13.4173 17 17 13.4173 17 9C17 4.58273 13.4173 1 9 1ZM12.3022 10.0863C12.2482 10.1403 12.223 10.2158 12.2338 10.2914L12.8921 14.1331C12.9245 14.3237 12.7266 14.4676 12.5576 14.3777L9.10791 12.5647C9.03957 12.5288 8.96043 12.5288 8.89209 12.5647L5.44245 14.3777C5.27338 14.4676 5.07554 14.3237 5.10791 14.1331L5.76619 10.2914C5.78058 10.2158 5.75539 10.1403 5.69784 10.0863L2.90647 7.36691C2.76978 7.23381 2.84532 7 3.03597 6.97122L6.89209 6.41007C6.96763 6.39928 7.03237 6.35252 7.06835 6.28417L8.79137 2.78777C8.8777 2.61511 9.1223 2.61511 9.20504 2.78777L10.9281 6.28417C10.9604 6.35252 11.0288 6.39928 11.1043 6.41007L14.9604 6.97122C15.1511 7 15.2266 7.23381 15.0899 7.36691L12.3022 10.0863Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6f1a301a753fa244b3140c19812ee5f7.svg";
export { ForwardRef as ReactComponent };